import { render } from "./Questions.vue?vue&type=template&id=3e439e4d&scoped=true&ts=true"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"

import "./Questions.vue?vue&type=style&index=0&id=3e439e4d&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/Development/Stefania/assessment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e439e4d"]])

export default __exports__